import client from './client';

const eqpUrl = '/api/v1/eqp';

// ============================= 공구 사용·교체 시기 =============================
// 매거진 탭 2차 기능 - 공구별 누적 가공시간/장착횟수/교체기준, 기준 설정, 교체(리셋), 타임라인.
// 응답 봉투는 eqpMagazine.js 와 동일(info 아래) - extractInfo 로 그대로 꺼낸다.

export const getToolUsage = (eqpUuid) =>
  client.get(`${eqpUrl}/${eqpUuid}/tools/usage`);

export const setToolLife = (eqpUuid, toolNo, body) =>
  client.put(`${eqpUrl}/${eqpUuid}/tools/${toolNo}/life`, body);

export const resetTool = (eqpUuid, toolNo, body) =>
  client.post(`${eqpUrl}/${eqpUuid}/tools/${toolNo}/reset`, body || {});

export const getToolTimeline = (eqpUuid, { from, to }) =>
  client.get(`${eqpUrl}/${eqpUuid}/tools/timeline`, { params: { from, to } });

export const extractInfo = (res) => res?.data?.info ?? null;
